import stringToNumber from "src/utils/stringToNumber";
import * as yup from "yup";

const addAndChangeSchemaObjectives = (translate: Function, language:string) => yup.object().shape({
	mea003Nome: yup.string().required(translate("Nome é requerido")),
	mea003Descricao: yup.string().required(translate("Descrição é requerida")),
	mea003Calcperc: yup.number().required(translate("Calcular percentual por é requerido")),
	mea003Peso: yup.number().required(translate("Peso é requerido")),
	metba004: yup.array().of(yup.object().shape({
		mea004Iqc001Id: yup.string().required(translate("Indicador é requerido"))
	})),
	metba006: yup.array().of(schemaMetrics(translate,language))
});

const schemaMetrics = (translate: Function,language:string) => yup.object().shape({
	mea006Cor: yup.string().required(translate("Cor da faixa é requerida")),
	mea006Valorini: yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("Valor inicial a faixa é requerida"))
		.typeError(translate("Valor inicial está incorreto")),
	mea006Valorfim:yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("Valor final da faixa é requerida"))
		.typeError(translate("Valor final está incorreto"))
		.when("mea006Valorini",(initiaValue,schema) => initiaValue ? schema.min(initiaValue,translate("Valor inicial não pode ser menor que o final")):schema)
});

export default addAndChangeSchemaObjectives;
